import React from "react"
import styled from "@emotion/styled"
import { Link } from "gatsby"

import ArrowDark from "../../images/icons/arrow-dark.svg"

const ArrowImg = styled.div`
  background: url(${ArrowDark});
  transform: rotate(180deg);
  width: 18px;
  height: 10px;
  margin-right: 16px;
  transition: 0.2s;
`

const ReadMore = styled(Link)`
  display: flex;
  align-items: center;
  font-weight: 600;
  margin-bottom: 32px;
  cursor: pointer;
  text-decoration: none;
  color: ${props => props.theme.shade[0]};
  p {
    margin: 0;
  }
  :hover {
    ${ArrowImg} {
      transform: translate(-6px, 0) rotate(180deg);
    }
  }
`

export default function NewsArticle(props) {
  return (
    <ReadMore to="/news/">
      <ArrowImg />
      <p>Back to News &amp; Events</p>
    </ReadMore>
  )
}
